import React from 'react';
import { Layout, Cell } from '@wix/design-system';
import { AppBox } from '../app-box';
import { SolutionProvider } from '../contexts/solution';
import { ConsumerPreferencesProvider } from '../contexts/consumer-preferences';
import { ConsumerCallbacksProvider } from '../contexts/consumer-callbacks';
export function AppsGridBox({ solutions, finalColumns, onClick, onInstalledAppClick, showViewAppButton, showDeveloperName, showRating, showPricing, showTopBadge, skin, }) {
    return (React.createElement(Layout, { gap: "24px", rowHeight: "1fr" }, solutions.map((solution, index) => (React.createElement(Cell, { span: 12 / finalColumns, key: solution?.id || index },
        React.createElement(ConsumerCallbacksProvider, { callbacks: {
                onClick,
                onInstalledAppClick,
            } },
            React.createElement(ConsumerPreferencesProvider, { preferences: {
                    showViewAppButton,
                    showDeveloperName,
                    showRating,
                    showPricing,
                    showTopBadge,
                    skin,
                } },
                React.createElement(SolutionProvider, { solution: solution },
                    React.createElement(AppBox, null)))))))));
}
//# sourceMappingURL=AppsGridBox.js.map